routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.orders', {
      url: __env.routes.orders,
      template: `<orders sh-ctrl="shCtrl"></orders>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/orders.config.js
 **/